export const settings = {
  app: {
    name: "DocuTalk",
  },
  // Cookie Names
  cookies: {
    refresh_token: "docutalk_web_refresh_token",
    access_token: "docutalk_web_access_token",
    user: "docutalk_web_user",
    organization: "docutalk_web_organization",
  },
  // API Endpoints
  api: {
    base: import.meta.env.VITE_API_URL,
    auth: {
      login: "/api/auth/login",
      register: "/api/auth/register",
      logout: "/api/auth/logout",
      check: "/api/auth/check",
      refresh: "/api/auth/refresh",
    },

    chat: {
      messages: (threadId: string) => `/api/chat/messages/${threadId}`,
      send: "/api/chat/send",
      get_groups: (userId: string) => `/api/groups/users/${userId}`,
      get_threads_by_user: `/api/threads/by-user`,
      create_thread: "/api/threads",
      delete_thread: (thread_id: string) => `/api/threads/${thread_id}`,
      rename_thread: "/api/chat/rename",
    },

    memory: {
      get_all: "/api/memory",
      search: "/api/memory/search",
      get_by_id: (id: string) => `/api/memory/${id}`,
      create: "/api/memory",
      update: (id: string) => `/api/memory/${id}`,
      delete: (id: string) => `/api/memory/${id}`,
      delete_all: "/api/memory/all",
    },
  },

  // Theme Colors
  colors: {
    primary: "#7C3AED", // Purple
    secondary: "#27293D", // Dark blue-gray
    background: "#1E1E2F", // Darker blue-gray
    text: {
      primary: "#FFFFFF",
      secondary: "#A0AEC0",
    },
    error: "#EF4444", // Red
    success: "#10B981", // Green
  },

  // Chat Configuration
  chat: {
    maxMessageLength: 2000,
    messageLoadLimit: 50,
    typingIndicatorTimeout: 3000,
  },

  // UI Configuration
  ui: {
    sidebarWidth: "16rem",
    headerHeight: "4rem",
    borderRadius: "0.5rem",
    transitionDuration: "200ms",
  },
};
